import { Dispatch } from "redux";
import { loadAndTrack } from "redux-request-loading";

import { submitQuestionnaireSuccess } from "@teamprevent/common/questionnaires/actions";
import { AnsweredQuestionWithId } from "@teamprevent/common/questionnaires/model";
import { MANAGER_SATISFACTION_FOLLOW_UP_QUESTIONNAIRE } from "@teamprevent/common/managerSatisfactionFollowUpQuestionnaire/models";

import { satisfactionFollowUpQuestionnaireApi } from "./satisfactionFollowUpQuestionnaireApi";

export const submitManagerSatisfactionFollowUpQuestionnaire = (ohCaseId: string, taskId: string, questions: AnsweredQuestionWithId[]) => {
    return async (dispatch: Dispatch) => {
        await loadAndTrack(dispatch, MANAGER_SATISFACTION_FOLLOW_UP_QUESTIONNAIRE, satisfactionFollowUpQuestionnaireApi.submit(ohCaseId, taskId, questions));
        dispatch(submitQuestionnaireSuccess(MANAGER_SATISFACTION_FOLLOW_UP_QUESTIONNAIRE));
    };
};
